/**
 * Gets the next upsell sub-sequence based on the current upsell and purchase decision
 *
 * @param {Object} params - Parameters
 * @param {Array<Object>} params.sequenceTree - Normalized sequence tree from upsell
 * @param {string} params.currentUpsellId - Current upsell ID
 * @param {boolean} params.wasPurchased - Whether the current upsell was purchased
 * @returns {Array<Object>|null} Next sub-sequence or null if sequence is complete
 */
export const getNextUpsell = ({ sequenceTree, currentUpsellId, wasPurchased, }) => {
    if (!sequenceTree || !Array.isArray(sequenceTree)) {
        return null;
    }
    const findNode = (nodes) => {
        for (const node of nodes) {
            if (node.id === currentUpsellId) {
                return node;
            }
            if (node.onPurchase && Array.isArray(node.onPurchase)) {
                const found = findNode(node.onPurchase);
                if (found)
                    return found;
            }
            if (node.onDecline && Array.isArray(node.onDecline)) {
                const found = findNode(node.onDecline);
                if (found)
                    return found;
            }
        }
        return null;
    };
    const currentNode = findNode(sequenceTree);
    if (!currentNode) {
        return null;
    }
    return (wasPurchased ? currentNode.onPurchase : currentNode.onDecline) ?? null;
};
